import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import sc from 'styled-components';

const StyledSpinner = sc.p`
  text-align: center;
  margin: 0 0 20px 0;
`;

const StyledDoneButton = sc(Button)`
  display: none;
  margin: 10px 10px 10px 10px;
`;

const KeyManagerCreateProgressView = ({ status, onHideModal }) => (
  <React.Fragment>
    <StyledSpinner className="loading-spinner">Creating in progress... {status}</StyledSpinner>
    <StyledDoneButton className="button-cancel" type="primary" onClick={onHideModal}>Close</StyledDoneButton>
  </React.Fragment>
);

export default KeyManagerCreateProgressView;

KeyManagerCreateProgressView.propTypes = {
  onHideModal: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};
